import initialState from 'SRC/modules/redux/initialState'
import actionTypes from 'SRC/modules/redux/actionTypes'

export const checkRegistrationCostReducer = (state = initialState.checkRegistrationCost, action) => {
  switch (action.type) {
    case actionTypes.SET_REGISTRATION_PRICE_FORM_DATA:
      return { ...state, formData: action.payload }
    case actionTypes.SET_REGISTRATION_PRICE_INQUIRY_CONFIRMATION:
      return { ...state, inquiryConfirmation: action.payload }
    case actionTypes.SET_REGISTRATION_PRICE_LOADING:
      return { ...state, isLoading: action.payload }
    case actionTypes.SET_REGISTRATION_PRICE_ERROR:
      return { ...state, error: action.payload }
    default:
      return state
  }
}
